<template>
  <qx-card-form title="GPS信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="serviceName" slot-scope="prop">
        <ChooseServicer
          :isRadio="true"
          :disabled="disabled"
          :otherSearchData="{
            serviceType: 7,
          }"
          v-model="prop.form.serviceName"
        />
      </section>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
import {
  getFileUrl,
} from 'api';
import ChooseServicer from 'components/choose/servicer';
export default {
  components: {
    ChooseServicer,
  },
  data () {
    return {
      disabled: false,
      otherFormData: {
      },
      baseForm: {
        suitTypeOptions: [],
        form: [
          {
            label: '服务商',
            value: 'serviceName',
            default: {},
            slot: true,
          },
          {
            label: '设备号',
            value: 'equipmentNumber',
            type: 'input',
            placeholder: ' ',
            disabled: false,
          },
          {
            label: '服务失效时间',
            value: 'serviveLoseDate',
            type: 'date',
            attr: {
              type: 'datetime',
              time: '00:00:00',
            },
            disabled: false,
          },
          {
            label: '套装类型',
            value: 'suitType',
            type: 'select',
            default: '1',
            onChange: (suitType) => {
              this.equoipmentChange(`${suitType}`);
            },
          },
          { label: 'GPS套装费用', value: 'suitFee', type: 'input', placeholder: ' ', disabled: false },
          { label: '定位设备品牌', value: 'gpsEquoipmentBrand', type: 'input', placeholder: ' ', hide: true, disabled: false },
          { label: '定位设备型号', value: 'gpsEquoipmentModel', type: 'input', placeholder: ' ', hide: true, disabled: false },
          { label: '定位设备号', value: 'gpsEquoipmentNumber', type: 'input', placeholder: ' ', hide: true, disabled: false },
          { label: '油耗设备品牌', value: 'oilWearEquoipmentBrand', type: 'input', placeholder: ' ', hide: true, disabled: false },
          { label: '油耗设备型号', value: 'oilWearEquoipmentModel', type: 'input', placeholder: ' ', hide: true, disabled: false },
          { label: '油耗设备号', value: 'oilWearEquoipmentNumber', type: 'input', placeholder: ' ', hide: true, disabled: false },
          {
            label: '上传证件图片',
            value: 'picList',
            type: 'img',
            accept: 'image/*',
            fileSize: 51200000000,
            attr: {
              limit: 5,
            },
            default: [],
          },
        ],
        rules: {
          serviveLoseDate: [
            { required: true, message: '请输入服务失效时间', trigger: 'blur' },
          ],
          suitType: [
            { required: true, message: '请选择套装类型', trigger: 'blur' },
          ],
          suitFee: [
            { required: true, message: '请选择GPS套装费用', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    setOptions (options) {
      this.baseForm.suitTypeOptions = options;
    },
    // 设备切换显示
    equoipmentChange (suitType) {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: true,
        names: ['gpsEquoipmentBrand', 'gpsEquoipmentModel', 'gpsEquoipmentNumber', 'oilWearEquoipmentBrand', 'oilWearEquoipmentModel', 'oilWearEquoipmentNumber'],
      });
      switch (suitType) {
        case '1':
          // 显示定位设备
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'hide',
            value: false,
            names: ['gpsEquoipmentBrand', 'gpsEquoipmentModel', 'gpsEquoipmentNumber'],
          });
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'disabled',
            value: !!this.$route.query.id,
            names: ['gpsEquoipmentBrand', 'gpsEquoipmentModel', 'gpsEquoipmentNumber'],
          });
          break;
        case '2':
          // 显示油耗设备
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'hide',
            value: false,
            names: ['oilWearEquoipmentBrand', 'oilWearEquoipmentModel', 'oilWearEquoipmentNumber'],
          });
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'disabled',
            value: !!this.$route.query.id,
            names: ['oilWearEquoipmentBrand', 'oilWearEquoipmentModel', 'oilWearEquoipmentNumber'],
          });
          break;
        case '3':
          // 显示定位和油耗设备
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'hide',
            value: false,
            names: ['gpsEquoipmentBrand', 'gpsEquoipmentModel', 'gpsEquoipmentNumber', 'oilWearEquoipmentBrand', 'oilWearEquoipmentModel', 'oilWearEquoipmentNumber'],
          });
          this.setFormAttrVal({
            form: this.baseForm,
            attr: 'disabled',
            value: !!this.$route.query.id,
            names: ['gpsEquoipmentBrand', 'gpsEquoipmentModel', 'gpsEquoipmentNumber', 'oilWearEquoipmentBrand', 'oilWearEquoipmentModel', 'oilWearEquoipmentNumber'],
          });
          break;
        default:
          break;
      }
    },
    // 统一处理数据格式
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData.serviveLoseDate = this.formatDate(formData.serviveLoseDate, 1);
        if (formData.picList && formData.picList.length) {
          for (let item of formData.picList) {
            item.fileId = item.id;
            item.fileUrl = item.url;
          }
        }
        if (formData.serviceName) {
          formData.serviceUserId = formData.serviceName.serviceUserId;
          formData.servicePhone = formData.serviceName.mobilePhone;
          formData.serviceName = formData.serviceName.serviceName;
        }
      }
      // console.log('缓存数据', formData);
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        formData.picFileIds = '';
        if (formData.picList && formData.picList.length) {
          let picFileIds = [];
          for (let item of formData.picList) {
            picFileIds.push(item.fileId);
          }
          formData.picFileIds = picFileIds.join();
        }
        delete formData.picList;
      }
      console.log('gps提交参数', formData);
      return formData;
    },
    async init (data = {}) {
      this.$refs.baseForm.reset();

      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: !!this.$route.query.id,
        names: ['equipmentNumber', 'serviveLoseDate', 'suitFee'],
      });
      this.disabled = !!this.$route.query.id;

      if (data.suitFee !== undefined) {
        data.suitFee = data.suitFee / 100;
      }

      if (data.suitType !== undefined) {
        data.suitType = String(data.suitType || '1');
      } else {
        data.suitType = this.baseForm.suitTypeOptions[0].value;
      }

      if (data.serviceName) {
        data.serviceName = {
          serviceName: data.serviceName,
          serviceUserId: data.serviceUserId,
          mobilePhone: data.servicePhone,
        };
      }

      let flowIds = [];
      if (data.picList && data.picList.length) {
        const picList = JSON.parse(JSON.stringify(data.picList));
        picList.forEach((item) => {
          flowIds.push(item.fileId);
        });
      }
      if (flowIds.length) {
        const imgs = await getFileUrl({
          flowIds: flowIds.join(),
          _GRID_TYPE: 'jq',
        });
        imgs.rows.forEach((img) => {
          data.picList.forEach((pic) => {
            if (pic.fileId === img.flowId) {
              pic.id = img.flowId;
              pic.url = img.fullPath;
            }
          });
        });
      }
      this.equoipmentChange(data.suitType);
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
